import React, { useState } from 'react'
import { ProfileWrapper } from '@/shared/components/CardWrapper'
import DateRange from '@/shared/components/DateRange';
import { useTranslation } from 'react-i18next';
import { format } from "date-fns";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shared/ui/alert-dialog"
import { toast } from 'react-toastify';
import Loader from '@/shared/components/Loader';
import { useDeleteOrgReportsMutation } from '@/api/rtk/mutationsApi'

const Data = () => {
  const { t } = useTranslation();
  const [deleteOrgReports] = useDeleteOrgReportsMutation();
  const [alertDateFrom, setAlertDateFrom] = useState(null);
  const [alertDateTo, setAlertDateTo] = useState(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async ({ dateFrom, dateTo, setDateFrom, setDateTo }) => {
    setAlertDateFrom(dateFrom);
    setAlertDateTo(dateTo);
    setIsAlertOpen(true);
    setDateFrom(null);
    setDateTo(null);
  };

  const handleDelete = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      const response = await deleteOrgReports({ dateFrom: alertDateFrom, dateTo: alertDateTo }).unwrap();
      if (response?.message) toast.success(t("profile.data.deleteSuccess"));
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete organization data. Please try again.');
    } finally {
      setAlertDateFrom(null);
      setAlertDateTo(null);
      setLoading(false);
      setIsAlertOpen(false);
    }
  };

  return (
    <ProfileWrapper
      title={t("profile.tabs.data")}
      description={t("profile.data.description")}
      hasButton={false}
    >
      <div className="space-y-4">
        <DateRange
          buttonText={t("actions.delete")}
          onSubmit={handleSubmit}
          loading={false}
          action='delete'
        />

        <AlertDialog open={isAlertOpen} onOpenChange={!loading ? setIsAlertOpen : undefined}>
          <AlertDialogContent className='w-fit'>
            <AlertDialogHeader>
              <AlertDialogTitle>{t("profile.data.confirmTitle")}</AlertDialogTitle>
              <AlertDialogDescription
                dangerouslySetInnerHTML={{
                  __html: t("profile.data.confirmDescription", {
                    startDate: alertDateFrom ? format(alertDateFrom, "dd.MM.yyyy") : "",
                    endDate: alertDateTo ? format(alertDateTo, "dd.MM.yyyy") : ""
                  })
                }}
              />
            </AlertDialogHeader>
            <AlertDialogFooter className='flex sm:justify-start'>
              <AlertDialogCancel className='w-full' disabled={loading}>{t("actions.cancel")}</AlertDialogCancel>
              <AlertDialogAction className='w-full bg-red-500 hover:bg-red-600' onClick={handleDelete} disabled={loading}>
                {loading ? <Loader /> : t("actions.delete")}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </ProfileWrapper>
  )
}

export default Data